import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import {
  DATABASE_CLIENT_PAGE,
  DATABASE_VEHICULE_PAGE,
  FERRAILLEURS_ENCHERES_VISIBLES_PAGE,
  PRAMETRAGE_PAGE,
  RESEAU_PAGE,
  VHU_LOTS_PAGE,
  VVINAL_PAGE,
} from "../../routes/routeConstants";

const modules = [
  {
    title: "Base vehicules",
    description: "Consulter, importer et maintenir le referentiel des vehicules.",
    icon: "ri-car-line",
    accent: "blue",
    path: DATABASE_VEHICULE_PAGE,
    meta: "Referentiel",
  },
  {
    title: "Clients",
    description: "Centraliser les profils clients et leurs informations utiles.",
    icon: "ri-user-3-line",
    accent: "green",
    path: DATABASE_CLIENT_PAGE,
    meta: "Gestion",
  },
  {
    title: "Valeur venale",
    description: "Calculer et verifier les valeurs selon les criteres metier.",
    icon: "ri-currency-line",
    accent: "amber",
    path: VVINAL_PAGE,
    meta: "Evaluation",
  },
  {
    title: "Parametrage",
    description: "Administrer les coefficients, barremes et valeurs de reference.",
    icon: "ri-settings-3-line",
    accent: "slate",
    path: PRAMETRAGE_PAGE,
    meta: "Configuration",
  },
  {
    title: "Lots VHU",
    description: "Gerer les lots multi-vehicules hors usage et suivre les offres.",
    icon: "ri-recycle-line",
    accent: "amber",
    path: VHU_LOTS_PAGE,
    meta: "VHU",
  },
  {
    title: "Ferrailleurs",
    description: "Consulter les encheres visibles, les achats et les conditions.",
    icon: "ri-user-star-line",
    accent: "green",
    path: FERRAILLEURS_ENCHERES_VISIBLES_PAGE,
    meta: "Portail",
  },
  {
    title: "Reseau",
    description: "Administrer les groupes et les profils de ferrailleurs.",
    icon: "ri-team-line",
    accent: "slate",
    path: RESEAU_PAGE,
    meta: "Ciblage",
  },
];

function ModuleSelectorPage() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const username = useMemo(() => {
    const authUser = localStorage.getItem("authUser");

    if (!authUser) {
      return "Admin";
    }

    try {
      const user = JSON.parse(authUser);
      const displayValue =
        user?.name ||
        user?.username ||
        user?.email ||
        user?.user?.name ||
        user?.user?.username ||
        user?.user?.email;

      if (!displayValue) {
        return "Admin";
      }

      const cleanName = displayValue.includes("@")
        ? displayValue.split("@")[0]
        : displayValue;

      return cleanName
        .split(/[._\s-]+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
    } catch (error) {
      console.error("Error parsing authUser from localStorage", error);
      return "Admin";
    }
  }, []);

  const formattedTime = currentTime.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const formattedDate = currentTime.toLocaleDateString("fr-FR", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <div className="page-content module-selector-page">
      <Container fluid>
        <div className="module-selector-hero">
          <div>
            <span className="module-selector-kicker">EXPERTAUTOEVAL</span>
            <h1>Choisissez votre espace de travail</h1>
            <p>
              Accedez rapidement au module dont vous avez besoin pour continuer
              vos operations.
            </p>
          </div>
          <div className="module-selector-session">
            <div className="module-session-user">
              <span className="module-session-avatar">
                {username.charAt(0).toUpperCase()}
              </span>
              <div>
                <span>{username}</span>
                <small>Connecte</small>
              </div>
            </div>
            <div className="module-session-time">
              <i className="ri-time-line" />
              <div>
                <span>{formattedTime}</span>
                <small>{formattedDate}</small>
              </div>
            </div>
            <Button
              tag={Link}
              to="/logout"
              color="none"
              className="module-session-logout"
            >
              <i className="ri-shut-down-line" />
              <span>Logout</span>
            </Button>
          </div>
        </div>

        <Row className="module-grid">
          {modules.map((module) => (
            <Col xl={3} md={6} key={module.title}>
              <Link
                to={module.path}
                className={`module-card module-card-${module.accent}`}
                aria-label={`Ouvrir ${module.title}`}
              >
                <span className="module-card-icon">
                  <i className={module.icon} />
                </span>
                <span className="module-card-meta">{module.meta}</span>
                <strong>{module.title}</strong>
                <span>{module.description}</span>
                <span className="module-card-action">
                  Ouvrir <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default ModuleSelectorPage;
